export type ExportType = 'PDF' | 'CSV' | 'JSON';

export interface ExportLimitConfig {
  [key: string]: number;
}

export interface ChunkRange {
  label: string;
  start: number;
  end: number;
}

export interface ExportModalConfig {
  totalRecords: number;
  allowedExportTypes?: ExportType[];
  exportLimits?: ExportLimitConfig;
}

export interface ExportPayload {
  exportType: ExportType;
  start: number;
  end: number;
}

export const ExportModalDocumentFormatTypes = [
  { id: 'PDF', name: 'PDF' },
  { id: 'CSV', name: 'CSV' },
  { id: 'JSON', name: 'JSON' },
];

const PDF_FORMAT = ExportModalDocumentFormatTypes[0];
const CSV_FORMAT = ExportModalDocumentFormatTypes[1];
const JSON_FORMAT = ExportModalDocumentFormatTypes[2];

// Define your BASE (Default) formats here
export const SUPPORTING_EXPORT_FORMATS = {
  DEVICE_PAGE: [CSV_FORMAT, JSON_FORMAT],
  MARKETS_PAGE: [CSV_FORMAT, JSON_FORMAT],
  MMS_SALES_PAGE: [CSV_FORMAT, JSON_FORMAT],
  PRODUCTS_PAGE: [CSV_FORMAT, JSON_FORMAT],
  QUICK_PAY_PAGE: [CSV_FORMAT, JSON_FORMAT],
  SC_PAGE: [CSV_FORMAT, JSON_FORMAT],
};

/**
 * Global helper to get formats.
 * If isDebug is true, it ensures PDF is included.
 */
export const getSupportedFormats = (
  pageKey: keyof typeof SUPPORTING_EXPORT_FORMATS,
  isDebug: boolean,
) => {
  const base = [...SUPPORTING_EXPORT_FORMATS[pageKey]];

  if (isDebug) {
    const hasPdf = base.some(
      (f) => f.id === ExportModalDocumentFormatTypes[0].id,
    );
    return hasPdf ? base : [PDF_FORMAT, ...base];
  }

  return base;
};

export enum EExportPage {
  DEVICE = 'DEVICE_PAGE',
  MARKETS = 'MARKETS_PAGE',
  MMS_SALES = 'MMS_SALES_PAGE',
  PRODUCTS = 'PRODUCTS_PAGE',
  QUICK_PAY = 'QUICK_PAY_PAGE',
  SC = 'SC_PAGE',
}

export const EAllowedFieldsForExport = {
  [EExportPage.DEVICE]: [
    'OPERATORID',
    'SOURCEID',
    'SYNCDTM',
    'ACTIVE',
    'CREATEDON',
    'UPDATEDON',
    'MARKETID',
    'SN',
    'TYPE',
  ],
  [EExportPage.MMS_SALES]: [
    'OPERATOR',
    'MARKETID',
    'DEVICEID',
    'SOURCEORDERID',
    'NETTOTAL',
    'GROSSTOTAL',
    'ORDERDTM',
    'CREATEDON',
  ],
  [EExportPage.PRODUCTS]: [
    'OPERATORID',
    'PRODUCTID',
    'PRODUCTCODE',
    'PRODUCTNAME',
    'MARKETS',
    'INACTIVEMARKETS',
    'BARCODES',
    'COST',
    'PRICE',
    'ACTIVE',
    'CREATEDON',
    'UPDATEDON',
  ],
  [EExportPage.SC]: [
    'SCPID',
    'LEGACYID',
    'SUBAPPLICATION',
    'SHORTPRODUCTNAME',
    'PRODUCTNAME',
    'BARCODE',
    'PRODUCTIMAGE',
    'BRAND',
    'SPEC',
    'CATEGORY',
    'ACTIVE',
    'LASTCHANGEDTM',
    'CREATEDON',
    'UPDATEDON',
  ],
  [EExportPage.MARKETS]: [
    'SOURCEMARKETID',
    'NAME',
    'MARKETLOCATION',
    'OPERATORNAME',
    'ACTIVE',
    'UPDATEDON',
    'CREATEDON',
  ],
};
